export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1080,
    lg: 1360,
    xl: 1700,
  },
};
